// extracted by mini-css-extract-plugin
export default {"component":"nV7F5","widget":"tQkRD","new":"ixOkO"};